// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__7A8Gu","modal":"Modal_modal__JD3Nx","content":"Modal_content__TQFnp"};